import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hjb-gdpr',
  templateUrl: './gdpr.component.html',
  styleUrls: ['./gdpr.component.scss']
})
export class GdprComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
